module.exports = "/reports/directives/payrollReportUngroupedColumn-85c53c.html";